var module = angular.module('octopusApp.configuration');

module.controller('TeamAddMembersDialogController', function($scope, busy, $uibModalInstance, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.users = null;
  $scope.adding = { members: [] };

  isLoading.promise(octopusRepository.Users.all().then(function (users) {
    $scope.users = users;
  }));


  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    $uibModalInstance.close($scope.adding.members);
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/controllers/team_add_members_dialog_controller.js
// module id = 6320448637096785
// module chunks = 1